<template>
  <div class="header-box">
		<div class="top-img" >
			<div class="main">
				<router-link to="/"><img src='../../static/image/logo.png' class="top_img_list" style=""></router-link>
				<img src='../../static/image/rightlogo.png' class="top_img_list" style="float:right">
			</div>
		</div>
		<div class="tab-wrap">
			<div class="main tab-box">
				<p v-for="(item,index) in tabs" :key="index" class="tab-item-box" :class="item.name===$route.name ? 'tab-item-box-active' : ''">
					<router-link v-if="item.name != 'target'" class="tab-item" :to="item.url"><span :class="item.name===$route.name ? 'tab-item-active' : ''">{{item.title}}</span></router-link>
					<a v-if="item.name == 'target'"  :href="item.url" target="_blank" class="tab-item"><span :class="item.name===$route.name ? 'tab-item-active' : ''">{{item.title}}</span></a>
								
				</p>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {},
  data() {
  	return {
		tabs: [{name: 'index', title: '首页', url: '/'}, {name: 'active', title: '活动介绍', url: '/active'}, {name: 'graphic', title: '作品展示', url: '/graphic'}, {name: 'winners', title: '获奖名单', url: '/winners'},{name: 'target', title: '往届作品', url: 'http://nginx.wxls-bszgjgy.1062910021471783.cn-hangzhou.fc.devsapp.net/2022bszgjgyyjzj/#/index'}],
  	};
  },
  computed: {
	  image() {
		  return this.$route.name==='index' ? require('../../static/image/topBanner.png') : require('../../static/image/topBanner2.png')
	  }
  },
  mounted() {
	
  }
}
</script>

<style lang="less" scoped>
	.header-box {
		
	}
	.main{
		width: 1200px;
		margin: auto;
	}
	.top-img {
		width: 100%;
		padding: 15px 0;
		background-color: #dbecf9;
	}
	.tab-wrap {
		width: 100%;
		height: 60px;
		// min-width: 1200px;
		margin-top: -4px;
		display: flex;
		align-items: center;
		background: linear-gradient(#7ea7be 10%, #1F344A 80%);
	}
	.tab-box {
		display: flex;
		align-items: center;
		height: 100%;
		position: relative;
	}
	.tab-item-box {
		padding: 0 20px;
		border-right: 1px solid #fff;
		position: relative;
	}
	.tab-item-box:last-child {
		border-right: 0;
	}
	.tab-item-box-active::after {
		content: '';
		width: calc(100% - 20px);
		height: 4px;
		bottom: -9px;
		left: 10px;
		box-shadow: 0px 10px 0px #F3692B;
		position: absolute;
	}
	.tab-item {
		position: relative;
		color: #fff;
		text-decoration: none;
	}
	.tab-item span {
		font-size: 22px;
		font-weight: 400;
		line-height: 20px;
	}
	.tab-item span:hover {
		color: #F78928;
	}
	.tab-item-active {
		color: #F78928;
	}
	.top_img_list{
		width: 20%;
	}
	@media (min-width: 640px) and (max-width: 1200px) {
		.main{
			width: 100%;
		}
		.top_img_list{
			width: 25%;
		}
		.tab-wrap{
			height:40px
		}
		.tab-item span{
			font-size:16px
		}
		
	}
	@media (min-width: 320px) and (max-width: 640px) { 
		.top_img_list{
			width: 30%;
			margin: 0 10px;
		}
		.main{
			width: 100%;
		}

		.tab-wrap{
			height:40px
		}
		.tab-item-box{
			padding: 0;
			width: 25%;
			text-align: center;
		}
		.tab-item span{
			font-size:14px
		}
	
	}
</style>
